import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { ContactModel } from '../../contact/contact/contact.model';
import { ContactService } from '../../contact/contact/contact.service';
import { InvoiceTaxModel } from './invoicetax.model';
import { AccountsAndTaxesModel } from './accountsandtaxes.model';
import { EventEmitter } from '@angular/core';
import { Output, OnInit, AfterContentChecked } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { BankAccountModel } from '../../finanzas/bancos/bankaccount.model';
import { Observable } from "rxjs";
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ExpenseFormModel } from "./expenseform.model";
import { AccountModel } from '../../invoice/preinvoice/account.model';
import { InvoiceTaxesModel } from '../../invoice/preinvoice/invoicetaxes.model';
import { InvoiceLineModel } from './invoiceline.model';
import { TaxCalculator } from '../../../shared/taxCalculator';
import { ContactFormV2Component } from '../../../modules_v2/contacts/components/contact-form-v2/contact-form-v2.component';
import { CoreComponent } from '../../../core/header/core.component';
import { PaymentCardService } from '../../finanzas/paymentcard/paymentcard.service';
import { PaymentCardModel, PaymentCardTypes } from '../../finanzas/paymentcard/paymentcard.model';
import { consts, PAY_METHODS } from '../../../consts';
import { AddFileService } from '../../../shared/components/add-file/add-file.service';
import { ActualSelected, DatesCF, Utils } from '../../../shared/utils';
import moment from "moment";
import { UserCompanyModel } from '../../user/usercompany/usercompany.model';
import { AccountingModel } from '../../user/accountingModel/accountingModel.model';
import { AccountingModelService } from '../../user/accountingModel/accountingModel.service';
import { HttpClient } from '@angular/common/http';
import { FilesService } from '../../file/files.service';
import { ExpenseService } from './expense.service';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { EfectivoService } from '../../../services/finanzas/efectivo/efectivo.service';
import { Efectivo } from '../../../models/finanzas/efectivo/efectivo.model';
import { PartnersService } from '../../user/partnersequity/partners/partners.service';
import { PartnersModel } from '../../user/partnersequity/partners/partners.model';
import { FacturasIAService } from '../../../services/ia/facturasia.service';
import { DatosConvertidosEnFactura } from '../../../models/ia/facturas';
import { from, of } from 'rxjs';
import { ContactosService } from '../../../services/employees/contactos.service';
import { SubscriptionsService } from '../../../services/subscriptions/subscriptions.service';
import { ContactPropertyService } from '../../contact/contact/contact-property.service';
import { PagoEnFichero } from '../../../models/gastos/file.model';
import { PolizaCreditoService } from '../../../services/finanzas/poliza-credito/poliza-credito.service';
import { PolizaCredito } from '../../../models/finanzas/poliza-credito/poliza-credito.model';
import { DialogService } from '../../../shared/services/dialog.service';
import { MasterModel } from '../../../modules_v2/master/models/master.model';
import { Option } from '../../../shared/models/option.model';
import { MasterService } from '../../../modules_v2/master/services/master.service';
import { ActivityService } from '../../user/activity/activity.service';
import { map, delay } from 'rxjs/operators';

@Component({
    selector: 'convfact-expense-form',
    templateUrl: './expense-form.component.html',
    styleUrls: ['./expense.component.css'],
    standalone: false
})

export class ExpenseFormComponent implements OnInit, AfterContentChecked {

  @Input() preinvoice: ExpenseFormModel;
  @Input() accountsAndTaxes: AccountsAndTaxesModel;
  @Input() contacts: ContactModel;
  @Input() bankAccounts: BankAccountModel;

  @Output() onSave = new EventEmitter<any>();

  @Input() errors: object;

  ready: boolean = false;

  position = 'above';

  paidedCheck: boolean = false;
  noPaidedCheck: boolean = false;

  imageTempUrl: any = '';
  pdfTempUrl: any;
  pdfTemp: any;

  paymentCards: PaymentCardModel[] = [];

  aux: number;
  result: number;
  taxes: Array<InvoiceTaxModel>;
  taxesView: string[] = [];

  taxesInvoice: InvoiceTaxesModel[] = [];
  taxesToTheView: string[] = [];

  expenseCtrl: UntypedFormControl;
  filteredExpenses: Observable<AccountModel[]>;
  expenseList: AccountModel[] = [];

  entranceCtrl: UntypedFormControl;
  filteredEntrances: Observable<AccountModel[]>;
  entranceList: AccountModel[] = [];

  accountAndTaxesList = new AccountsAndTaxesModel;

  contactCtrl: UntypedFormControl;
  filteredContacts: Observable<ContactModel[]>;
  contactList: ContactModel[] = [];
  contactSelected: ContactModel;

  payMethod = PAY_METHODS;
  payMethodCtrl: UntypedFormControl;
  filteredPayMethod: Observable<any>;

  // Array estable (no un getter): app-autocomplete-select recibe [items] y lo
  // vuelve a procesar en ngOnChanges cada vez que cambia la referencia. Un
  // getter que hace .map() en cada ciclo de detección de cambios genera un
  // array nuevo constantemente, lo que reinicializa el control justo después
  // de seleccionar una opción y la selección por click no llega a cuajar.
  public payMethodOptions: Option[] = PAY_METHODS.map(method => ({ label: method, value: method }));

  originEntity: string = consts.INVOICE_ENTITY;
  filePath: string = consts.INVOICE_FILE_PATH;

  userCompany: UserCompanyModel;
  accounts: AccountingModel[] = [];

  readOnly: boolean = false;
  hasDuplicateExpense: boolean;

  readyLoadedFiles: boolean = null;

  // Estado de subida de app-add-file, recibido vía (loadingChange) — bloquea
  // "Guardar" mientras haya un archivo subiéndose (ver plantilla).
  attachmentUploading: boolean = false;
  onAttachmentUploadingChange(value: boolean): void {
    this.attachmentUploading = value;
  }

  newContactLoaded = new BehaviorSubject<boolean>(true);

  private accountingExpenseAccountsKeywords: { keywords: string[], account: string }[] = [{ keywords: [], account: '' }];

  public efectivoList: Efectivo[] = [];
  public sociosList: PartnersModel[] = [];
  public polizaCreditoList: PolizaCredito[] = [];


  // #region Propiedades relacionadas con la extracción de la información de las facturas y con la suscripción de IA
  contactoReconocidoForm: UntypedFormControl = new UntypedFormControl();
  contactoReconocido: ContactModel = null;
  datosFacturaIA: DatosConvertidosEnFactura = null;
  subscripcionIAActiva: boolean = false;
  // #endregion

  contactProperties = [];
  isProjectEnable: boolean = false;

  public saved: boolean = false;

  projects: MasterModel[] = [];
  expenseProjectType: MasterModel[] = [];

  constructor(
    public snackBar: MatSnackBar,
    private contactService: ContactService,
    private core: CoreComponent,
    public dialog: MatDialog,
    private ref: ChangeDetectorRef,
    private addFileService: AddFileService,
    private taxCalculator: TaxCalculator,
    private paymentCardService: PaymentCardService,
    private accountingModelService: AccountingModelService,
    public http: HttpClient,
    private fileService: FilesService,
    public facturasIAService: FacturasIAService,
    public expenseService: ExpenseService,
    private efectivoService: EfectivoService,
    private partnersService: PartnersService,
    private contactosService: ContactosService,
    private susbscriptionsService: SubscriptionsService,
    private contactPropertyService: ContactPropertyService,
    private polizaCreditoService: PolizaCreditoService,
    private cdr: ChangeDetectorRef,
    private dialogService: DialogService,
    private masterService: MasterService,
    private activityService: ActivityService,
  ) { }

  private fillManuallyExpensesKeywords(): void {
    this.accountingExpenseAccountsKeywords = [
      {
        keywords: ['compras', 'mercadería', 'alimento', 'existencia', 'materia prima', 'artículo', 'producto', 'comida', 'proveedor'],
        account: '6000000001'
      },
      {
        keywords: ['compras', 'mercadería', 'alimento', 'existencia', 'materia prima', 'artículo', 'producto', 'comida', 'proveedor'],
        account: '6010000001'
      },
      {
        keywords: ['productos limpieza', 'embalajes', 'envases', 'repuestos', 'materiales', 'menaje'],
        account: '6020000001'
      },
      {
        keywords: ['descuento', 'rebaja', 'pronto pago', 'pago'],
        account: '6060000001'
      },
      {
        keywords: ['servicio', 'colaborador', 'externo', 'otra', 'empresa'],
        account: '6070000001'
      },
      {
        keywords: ['devolución', 'merma', 'rotura', 'avería', 'desecho'],
        account: '6080000001'
      },
      {
        keywords: ['descuento', 'rebaja', 'volumen'],
        account: '6090000001'
      },
      {
        keywords: ['investigación', 'desarrollo', 'mejora'],
        account: '6200000001'
      },
      {
        keywords: ['alquiler', 'arrendamiento', 'oficina', 'nave'],
        account: '6210000001'
      },
      {
        keywords: ['mantenimiento', 'reparación', 'arreglo', 'reparar', 'fontanero', 'técnico', 'albañil', 'operario', 'peón'],
        account: '6220000001'
      },
      {
        keywords: ['servicio', 'consulta', 'abogado', 'asesor', 'contable', 'gestor', 'notario', 'tramite', 'gestión'],
        account: '6230000001'
      },
      {
        keywords: ['transporte', 'traslado', 'porte'],
        account: '6240000001'
      },
      {
        keywords: ['prima', 'seguro', 'poliza', 'parte', 'planes'],
        account: '6250000001'
      },
      {
        keywords: ['comisión', 'liquidación', 'mantenimiento'],
        account: '6260000001'
      },
      {
        keywords: ['redes', 'sociales', 'internet', 'publicidad', 'promoción', 'panfletos', 'flayers', 'tarjetas visitas'],
        account: '6270000001'
      },
      {
        keywords: ['agua', 'gas', 'gasolina', 'gasoil', 'luz', 'electricidad', 'endesa', 'iberdrola'],
        account: '6280000001'
      },
      {
        keywords: ['comidas', 'dietas', 'varios', 'otros', 'gasto', 'reunión'],
        account: '6290000001'
      },
      {
        keywords: ['ibi', 'basura', 'tasa', 'tributo', 'recaudación'],
        account: '6310000001'
      },
      {
        keywords: ['sueldo', 'salario', 'nomina', 'personal', 'coste'],
        account: '6400000001'
      },
      {
        keywords: ['seguridad', 'social', 'compañía', 'coste', 'laboral'],
        account: '6420000001'
      }
    ]
  }

  newContact(isExpense: boolean) {
    const contactScratch = new ContactModel();

    if (isExpense) {
      contactScratch.isProvider = true;
      contactScratch.isClient = false;
    } else {
      contactScratch.isProvider = false;
      contactScratch.isClient = true;
    }

    contactScratch.isPhysical = true;

    const dialogNewContact = ContactFormV2Component.open(this.dialog, { scratch: contactScratch });

    this.newContactLoaded.next(false);

    dialogNewContact
      .pipe(
        map(value => {
          if (value === undefined) {
            this.newContactLoaded.next(true);
          }
          return value;
        }),
        delay(1200)
      )
      .subscribe(result => {
        if (result !== undefined) {
          this.contactService.getListProviders().then(response => {
            if (response.length == this.contactList.length) {
              this.contactList = response;
              this.newContactLoaded.next(null);
            } else {
              this.contactList = response;
              this.newContactLoaded.next(true);
            }
          }).catch(() => {
            this.newContactLoaded.next(true);
            this.displayInfo('Ha ocurrido un error inesperado al obtener el listado de contactos');
          });

          this.contactosService.listaProveedores();
        }
      });
  }

  paided() {
    this.noPaidedCheck = false;
    this.paidedCheck = true;
    this.preinvoice.paided = new Date();
  }

  noPaided() {
    this.paidedCheck = false;
    this.noPaidedCheck = true;
  }

  /**
   * Calcula el subtotal de la factura.
   *
   * @returns El subtotal calculado.
   */
  calcularSubtotal() {
    return this.taxCalculator.calcularSubtotal(this.preinvoice);
  }

  /**
   * Calcula el total de la pre-factura.
   *
   * @returns El total de la pre-factura.
   */
  calcularTotal() {
    this.preinvoice.total = this.taxCalculator.calcularTotal(this.preinvoice);
    return this.preinvoice.total;
  }

  impuestos(): string[] {
    const taxesView: string[] = [];
    const taxesInvoice: any[] = [];
    return this.taxCalculator.impuestos(this.preinvoice, undefined, undefined, taxesView, taxesInvoice, []);
  }

  filterPayMethod(val) {
    const self = this;
    for (const method of this.payMethod) {
      if (method == val) {
        self.preinvoice.typePay = method;
      }
    }

    return val ? this.payMethod.filter(s => s.toLowerCase().indexOf(val.toLowerCase()) === 0)
      : this.payMethod;
  }

  filterExpenses(val: string) {
    for (const account of this.expenseList) {
      if (account.number == val || account.name == val) {
        this.preinvoice.expenseAccount = account.number;
      }
    }

    if (val) {

      // Busqueda por palabra clave
      if (isNaN(parseInt(val, 10))) {
        const accountsFiltered = this.accountingExpenseAccountsKeywords.map(x => {

          if (x.keywords.findIndex(x => x.toLocaleLowerCase().startsWith(val.toLocaleLowerCase())) !== -1) {
            return x.account;
          }

        });

        return this.expenseList.filter(s => accountsFiltered.includes(s.number) || new RegExp(val.toLowerCase()).test(s.palabrasClave.toLowerCase()));
      }

      // Busqueda por el número de cuenta contable
      return this.expenseList.filter(s => s.number.toLowerCase().indexOf(val.toLowerCase()) === 0 || new RegExp(val.toLowerCase()).test(s.palabrasClave.toLowerCase()));
    }

    return this.expenseList;
  }

  /**
   * Filtra los contactos según el valor proporcionado y actualiza los datos de la pre-factura.
   *
   * @param val El valor utilizado para filtrar los contactos.
   * @returns Una lista de contactos filtrada según el valor proporcionado.
   */
  filterContacts(val) {
    const self = this;
    for (const contact of this.contactList) {
      if ((contact.companyName == val || (contact.vatNumber != null && contact.vatNumber.trim().toLocaleLowerCase() == val.trim().toLowerCase())) && contact.isProvider) {
        self.preinvoice.receiverUid = contact.uid;
        self.preinvoice.issuerName = contact.companyName;
        self.preinvoice.issuerVatNumber = contact.vatNumber;

        this.contactService.loadData(self.preinvoice.receiverUid).then(response => {
          this.contactSelected = response;

          this.contactPropertyService.getList(undefined, undefined, { contactUid: this.contactSelected.uid }).then(result => {
            this.contactProperties = result;
          });

          self.preinvoice.entranceAccount = response.entranceAccountProvider;
          self.preinvoice.expenseAccount = response.expenseAccountProvider;

          let account = null;
          if (self.preinvoice.entranceAccount == null || self.preinvoice.entranceAccount == '') {
            if (this.userCompany && this.userCompany.isSalesInvoice) {
              account = this.entranceList.filter(c => c.number == '7000000001')[0];
            }

            if (this.userCompany && this.userCompany.isServiceInvoice) {
              account = this.entranceList.filter(c => c.number == '7050000001')[0];
            }

            if (this.userCompany && this.userCompany.isSalesInvoice && this.userCompany.isServiceInvoice) {
              account = this.entranceList.filter(c => c.number == '7000000001')[0];
            }
          } else {
            account = this.entranceList.filter(c => c.number == response.expenseAccountProvider)[0];

          }

          if (account) {
            self.preinvoice.expenseAccount = account.number + ' - ' + account.name;
          }

          self.preinvoice.typePay = response.paymentTypeProvider;

          if (this.contactSelected.taxProviderUid != null) {
            const tax: InvoiceTaxModel = this.accountsAndTaxes['taxes'].find(x => x.uid === this.contactSelected.taxProviderUid)
            tax.taxId = tax.id;

            if (self.preinvoice.invoiceLines[0].customsValue == null) {
              // Comprueba si el impuesto ya está incluido en la lista de impuestos
              if (self.preinvoice.invoiceLines[0].taxes.find(x => x.uid == tax.uid) == null) {
                self.preinvoice.invoiceLines[0].taxes.push(tax);
              }
            }
          }
          if (this.contactSelected.taxProviderSecondUid != null) {
            const tax: InvoiceTaxModel = this.accountsAndTaxes['taxes'].find(x => x.uid === this.contactSelected.taxProviderSecondUid)
            tax.taxId = tax.id;

            if (self.preinvoice.invoiceLines[0].customsValue == null) {
              // Comprueba si el impuesto ya está incluido en la lista de impuestos
              if (self.preinvoice.invoiceLines[0].taxes.find(x => x.uid == tax.uid) == null) {
                self.preinvoice.invoiceLines[0].taxes.push(tax);
              }
            }
          }
          if (response.paymentProviderUid != null) {
            self.preinvoice.typePayBankAccount = response.paymentProviderUid;
          }
          if (response.providerEfectivoId != null) {
            self.preinvoice.efectivoId = response.providerEfectivoId;
          }
          if (response.providerPartnersId != null) {
            self.preinvoice.partnersId = response.providerPartnersId;
          }

          if (this.contactSelected.expirationProvider == null) {
            const expiration = self.preinvoice.invoiceRelease;
            self.preinvoice.invoiceExpiration = expiration;
          }
          else {
            self.preinvoice.invoiceExpiration = new Date(moment(self.preinvoice.invoiceRelease).add(this.contactSelected.expirationProvider, 'days').toDate());
          }

        });
      }
    }

    const normalizedValue = this.normalize(val);
    return val ? this.contactList.filter(contact => this.normalize(contact.companyName).includes(normalizedValue))
      : this.contactList;
  }

  // Normaliza la cadena eliminando diacríticos y convirtiéndola a minúsculas
  // NFD Descompone la consonante por ejemplo ñ -> n -> ~
  private normalize(str: string): string {
    return str != null ? str.normalize('NFD').replace(/[\u0300\u0301\u0303\u0327\u0308]/g, '').toLowerCase() : '';
  }


  getData() {
    this.hasDuplicateExpense = false;
    this.ready = false;
    this.payMethodCtrl = new UntypedFormControl();
    this.filteredPayMethod = this.payMethodCtrl.valueChanges
      .pipe(map(method => this.filterPayMethod(method)));

    this.contactList = [];

    this.contactService.getListProviders().then(response => {
      this.contactList = response;
    }).catch(err => {
      this.displayInfo('Ha ocurrido un error inesperado al obtener el listado de contactos');
    });



    this.contactCtrl = new UntypedFormControl();
    this.filteredContacts = this.contactCtrl.valueChanges
      .pipe(
        map(contact => contact && typeof contact === 'object' ? contact.companyName : contact),
        map(name => this.filterContacts(name))
      );

    this.accountingModelService.getList('gasto').then(data => {
      this.accounts = data;
      this.accounts.forEach(account => {
        if (Utils.AccountIsForExpenses(account.type)) {
          const temp: AccountModel = new AccountModel();
          temp.name = account.name;
          temp.number = account.number;
          temp.type = account.type;
          temp.palabrasClave = account.palabrasClave;
          this.expenseList.push(temp);
        } else if (Utils.AccountIsForFinancingInvestment(account.type)) {

          const keyWords = [];
          keyWords.push(account.name);
          keyWords.push(account.number);

          this.accountingExpenseAccountsKeywords.push({ keywords: keyWords, account: account.number });
          const temp: AccountModel = new AccountModel();
          temp.name = account.name;
          temp.number = account.number;
          temp.type = account.type;
          temp.palabrasClave = account.name + ', ' + account.number;
          this.expenseList.push(temp);
        }
      });
    });

    //Projects

    this.masterService.getProjects().subscribe(data => {
      this.projects = data;
      this.cdr.detectChanges();
    })

    this.masterService.getExpenseProjectTypes().subscribe(data => {
      this.expenseProjectType = data;
      this.cdr.detectChanges();
    })

    this.paymentCardService.getList(0).then(
      paymentCards => {
        this.paymentCards = paymentCards.list;
      })

    this.partnersService.list().then(
      response => {
        this.sociosList = response;
      })

    this.efectivoService.list()
      .then(response => this.efectivoList = response)

    this.polizaCreditoService.listPayments()
      .then(response => this.polizaCreditoList = response)

    this.expenseCtrl = new UntypedFormControl();
    this.filteredExpenses = this.expenseCtrl.valueChanges
      .pipe(
        map(account => account && typeof account === 'object' ? account.number : account),
        map(name => this.filterExpenses(name))
      );


    if (this.preinvoice.pdf) {
      this.readyLoadedFiles = false;
      this.addFileService.getImageFromFilesPDF(this.preinvoice.fileUid, this.originEntity).then(result => {
        this.changeFile(result);
        this.readyLoadedFiles = true;
      });

    } if (this.preinvoice.image) {
      this.readyLoadedFiles = false;
      this.addFileService.getImageFromFiles(this.preinvoice.fileUid, this.originEntity).then(response => {
        this.createImageFromBlob(response);
        this.readyLoadedFiles = true;
      });
    }

    this.ready = true;
  }

  ngOnInit() {
    this.fillManuallyExpensesKeywords();

    this.getData();

    this.activityService.loadData(ActualSelected.activitySelected).then(activity => {
      this.isProjectEnable = activity.isProject;
    });
    // Obtención de la lista de proveedores desde el servicio de Contactos.
    this.contactosService.listaProveedores();

    // Comprueba si el usuario tiene la suscripción de IA activa.
    this.susbscriptionsService.checkSubscriptionIA()
      .subscribe({
        next: (resultado: boolean) => {
          this.subscripcionIAActiva = resultado;
        }
      });

    if (this.preinvoice.receiverUid) {
      this.contactPropertyService.getList(undefined, undefined, { contactUid: this.preinvoice.receiverUid }).then(result => {
        this.contactProperties = result;
      });
    }
  }


  createImageFromBlob(image: Blob) {
    const reader = new FileReader();
    if (image) {
      reader.readAsDataURL(image);
      reader.onloadend = () => {
        this.imageTempUrl = reader.result;
        this.ref.detectChanges();
      }
      this.ref.detectChanges();
    }
  }

  SetFileParameters(event): void {
    this.preinvoice.image = event.Image;
    this.preinvoice.pdf = event.PDF;
    this.preinvoice.fileUid = event.FileUid;
    if (event.File && event.Image) {
      this.createImageFromBlob(event.File);

      // 16/004/2024 - Jose
      // Por ahora, se va a comentar la opción de poder reconocer los datos de la factura mediante IA para los archivos de tipo IMAGEN.
      // if (this.subscripcionIAActiva) {
      //   // Obtención de los datos de la factura mediante IA.
      //   this.obtenerDatosFacturaIA(event.FileUid);
      // }

    }
    if (event.PDF) {
      this.changeFile(event.File);

      // 16/004/2024 - Jose
      // Por ahora, se va a comentar la opción de poder reconocer los datos de la factura mediante IA para los archivos de tipo IMAGEN.
      // En el caso de que el usuario tenga la suscripción de la IA activa, se procede a la extracción de los datos de la factura.
      // if (this.subscripcionIAActiva) {
      //   this.obtenerDatosFacturaIA(event.FileUid);
      // }
    }
  }

  changeFile(data: any) {
    this.imageTempUrl = data;
    this.ref.detectChanges();
  }

  checkImage() {
    if (this.preinvoice.fileUid != null && this.preinvoice.fileUid != consts.EMPTY_GUID || this.preinvoice.image || this.preinvoice.pdf) {
      this.addFileService.getImageFromFiles(this.preinvoice.fileUid, this.originEntity).then(response => {
        this.createImageFromBlob(response);
      });
    }
  }

  ngAfterContentChecked() {
    // Tax breakdown and totals are computed via template method calls (impuestos, calcularSubtotal, calcularTotal)
    // to avoid ExpressionChangedAfterItHasBeenCheckedError from array mutation in lifecycle hooks
  }

  addInvoiceLine() {
    this.preinvoice.invoiceLines.push(new InvoiceLineModel());
  }

  addInvoiceLineIgicImport() {
    if (this.preinvoice.invoiceLines.find(element => element.customsValue !== undefined && element.customsValue !== null)) {
      this.displayInfo('No puedes añadir más de un concepto de IGIC de importación')
      return;
    }
    // 30122022 -> Es un valor "mágico" de control, nos indica que viene unicamente desde el formulario de gastos y es para marcar la linea de concepto como "IGIC Importación"
    const taxLine = new InvoiceLineModel();
    taxLine.customsValue = 30122022;
    this.preinvoice.invoiceLines.push(taxLine);
  }

  removeInvoiceLine(invoiceLine) {
    this.preinvoice.invoiceLines.splice(this.preinvoice.invoiceLines.indexOf(invoiceLine), 1);
    if (this.preinvoice.invoiceLines.length == 0) {
      this.preinvoice.invoiceLines.push(new InvoiceLineModel());
    }
  }

  public save(preinvoice) {
    let noError = true;


    // TODO - Tener en cuenta que esto modificará el valor de noError y dejará pasar/no controlará las anteriores validaciones
    if (preinvoice.uid == null && this.contactSelected != null && this.contactSelected.isProvider) {
      noError = this.checkPercentages();
      this.setMinValueToPercentages();
    }

    if (preinvoice.issuerName == null || preinvoice.issuerName == "" || preinvoice.issuerName == undefined) {
      noError = false;
      this.displayInfo("Debe especificar el contacto emisor del gasto");
      return;
    }

    if (preinvoice.invoiceNumber == null || preinvoice.invoiceNumber == "" || preinvoice.invoiceNumber == undefined) {
      noError = false;
      this.displayInfo("Debe especificar el número de la factura.");
      return;
    }

    if (preinvoice.expenseAccount == null || preinvoice.expenseAccount == "") {
      noError = false;
      this.displayInfo("Debe especificar la cuenta contable de gasto.");
      return;
    }

    if (preinvoice.invoiceRelease == null) {
      noError = false;
      this.displayInfo("Debe especificar la fecha de factura.");
      return;
    }

    if (preinvoice.invoiceExpiration == null) {
      noError = false;
      this.displayInfo("Debe especificar la fecha de vencimiento de la factura.");
      return;
    }

    if (this.paidedCheck) {
      if (preinvoice.typePay == null || preinvoice.typePay === "") {
        noError = false;
        this.displayInfo("El tipo de pago debe estar especificado.");
        return;
      }

      if (preinvoice.typePay === consts.TYPEPAY_CASH && (preinvoice.efectivoId == null || preinvoice.efectivoId == "")) {
        noError = false;
        this.displayInfo("Debe especificar la caja/efectivo.");
        return;
      }

      if ((preinvoice.typePay === "Transferencia bancaria" || preinvoice.typePay === "Cargo en cuenta"
        || preinvoice.typePay === consts.TYPEPAY_CONFIRMING || preinvoice.typePay === consts.TYPEPAY_PAGARES) &&
        (preinvoice.typePayBankAccount == null || preinvoice.typePayBankAccount == "" || preinvoice.typePayBankAccount == consts.EMPTY_GUID)) {
        noError = false;
        this.displayInfo("Debe especificar la cuenta bancaria.");
        return;
      }

      if (preinvoice.typePay === consts.TYPEPAY_CREDITCARD && (preinvoice.typePayBankAccount == null || preinvoice.typePayBankAccount == "" || preinvoice.typePayBankAccount == consts.EMPTY_GUID)) {
        noError = false;
        this.displayInfo("Debe especificar la tarjeta de crédito.");
        return;
      }

      if (preinvoice.typePay === consts.TYPE_DEBITCARD && (preinvoice.typePayBankAccount == null || preinvoice.typePayBankAccount == "" || preinvoice.typePayBankAccount == consts.EMPTY_GUID)) {
        noError = false;
        this.displayInfo("Debe especificar la tarjeta de débito.");
        return;
      }

      if (preinvoice.typePay === consts.TYPE_SOCIO && (preinvoice.partnersId == null || preinvoice.partnersId == "")) {
        noError = false;
        this.displayInfo("Debe especificar el socio.");
        return;
      }

      if (preinvoice.paided == null) {
        noError = false;
        this.displayInfo("Debe especificar la fecha del pago.");
        return;
      }
    }

    if (preinvoice.typePay !== consts.TYPEPAY_CASH) {
      preinvoice.efectivoId = null;
    }

    if (preinvoice.typePay !== consts.TYPE_SOCIO) {
      preinvoice.partnersId = 0;
    }

    if (noError) {
      this.expenseService.saveRequestUpdateValue(true);
      if (this.paidedCheck == false) {
        preinvoice.paided = null;
      }
      preinvoice.activityUid = this.core.activitySelected;
      preinvoice.fiscalYear = this.core.yearSelected;

      this.preventNullOrEmptyValues(preinvoice);
      this.onSave.emit(preinvoice);
    }

    //project
    if (noError) {

      preinvoice.ProjectUid = this.preinvoice.projectUid;
      preinvoice.ExpenseUid = this.preinvoice.expenseProjectTypeUid;


      this.expenseService.saveRequestUpdateValue(true);
      this.preventNullOrEmptyValues(preinvoice);

    }
  }

  preventNullOrEmptyValues(preinvoice) {
    for (let i = 0; i < preinvoice.invoiceLines.length; i++) {

      if (preinvoice.invoiceLines[i].unityAmount == null || preinvoice.invoiceLines[i].unityAmount === '') {
        preinvoice.invoiceLines[i].unityAmount = 0;
      }

    }
  }

  verifyDuplicateIssuerName(issuerName: string) {
    if (issuerName !== "" && this.preinvoice.invoiceNumber !== undefined) {
      if (this.preinvoice.invoiceNumber !== "") {
        this.expenseService.hasDuplicateExpense(issuerName, this.preinvoice.invoiceNumber)
          .then(response => this.hasDuplicateExpense = response);
      } else {
        this.hasDuplicateExpense = false;
      }
    } else {
      this.hasDuplicateExpense = false;
    }
  }

  verifyDuplicateInvoiceNumber(event: Event) {
    const invoiceNumberEl = event.target as HTMLInputElement;
    if (invoiceNumberEl.value !== "" && this.preinvoice.issuerName !== undefined) {
      if (this.preinvoice.issuerName !== "") {
        this.expenseService.hasDuplicateExpense(this.preinvoice.issuerName, this.preinvoice.invoiceNumber)
          .then(response => this.hasDuplicateExpense = response);
      } else {
        this.hasDuplicateExpense = false;
      }
    } else {
      this.hasDuplicateExpense = false;
    }
  }

  changeToggle(element, other) {
    this.preinvoice[other] = (this.preinvoice[element]);
  }

  displayInfo(message: string): void {
    // let options = new MatSnackBarConfig();
    // options.duration = 10000;
    // options.horizontalPosition = 'center';
    // options.panelClass = ['custom-snackbar', 'custom-snackbar-container'];
    // this.snackBar.open(message, '', options);
    this.dialogService.openAutoCloseDialog(message);
  }

  setExpiration(event: MatDatepickerInputEvent<Date>) {
    let auxDate = new Date();
    auxDate = event.value;

    if (auxDate != null && this.contactSelected != null &&
      this.contactSelected.expirationProvider != null &&
      DatesCF.toDate(auxDate.toLocaleDateString()).valid) {
      this.preinvoice.invoiceRelease = auxDate;
      this.preinvoice.invoiceExpiration = new Date(moment(auxDate).add(this.contactSelected.expirationProvider, 'days').toDate());

      if (this.contactSelected.expirationProvider === 0 && this.contactSelected.paymentTypeProvider === consts.TYPEPAY_CASH || this.contactSelected.paymentTypeProvider === consts.TYPEPAY_CREDITCARD) {
        this.preinvoice.paided = this.preinvoice.invoiceExpiration;
        this.paidedCheck = true;
      }
    }
  }

  checkPercentages(): boolean {
    let isOk = true;

    let total = 0;

    this.contactSelected.contactActivities.forEach(element => {
      total += element.percentage;
    });

    if (total != 100) {
      isOk = false;
      this.displayInfo("El total de las asignaciones del gasto por actividad debe ser 100%.");
    } else {
      this.preinvoice.contactActivities = this.contactSelected.contactActivities;
    }

    return isOk;
  }

  setMinValueToPercentages() {
    for (let i = 0; i < this.contactSelected.contactActivities.length; i++) {
      if (this.contactSelected.contactActivities[i].percentage == null) {
        this.contactSelected.contactActivities[i].percentage = 0;
      }
    }
  }


  // #region Métodos relacionados con los datos extra de las facturas

  /**
   * Obtiene los datos extra asociados con un documento (método de pago y fecha de pago).
   * @param event El evento que contiene los datos extra del documento.
   */
  onAplicarInfoFicheroRelacionado(event: PagoEnFichero): void {
    this.preinvoice.typePay = event.tipoPago;
    this.paidedCheck = true;
    this.preinvoice.paided = event.fechaPagoReal;

    setTimeout(() => {
      // Comprueba el resto de valores que viene con la información del Pago en fichero: tipo de efectivo, tipo de cuenta bancaria o el tipo de tarjeta
      if (event.tipoEfectivoReal != null && event.tipoEfectivoReal.trim().length > 0) {
        this.preinvoice.efectivoId = event.tipoEfectivoReal;
      }
      if (event.cuentaBancaria != null && event.cuentaBancaria.trim().length > 0) {
        this.preinvoice.typePayBankAccount = event.cuentaBancaria;
      }
      if (event.tipoTarjeta != null && event.tipoTarjeta.trim().length > 0) {
        this.preinvoice.typePayBankAccount = event.tipoTarjeta;
      }
    }, 500);

  }

  // #endregion

  // #region Métodos relacionados con la extracción de la información de las facturas

  /**
   * Aplica los datos de la factura obtenidos de la IA.
   */
  aplicarDatosFacturaIA(): void {
    if (this.datosFacturaIA !== null) {

      console.log('Datos de la factura', this.datosFacturaIA);
      console.log('Emisor', this.contactoReconocido);

      if (this.contactoReconocido != null) {
        this.preinvoice.invoiceLines = [];

        // Información en base al contacto
        // Se establece el contacto asociado a la empresa o CIF de la factura
        this.preinvoice.issuerName = this.contactoReconocido.companyName
        this.preinvoice.issuerVatNumber = this.contactoReconocido.vatNumber;
        this.preinvoice.receiverUid = this.contactoReconocido.uid;

        this.contactSelected = this.contactoReconocido;
        this.preinvoice.entranceAccount = this.contactoReconocido.entranceAccountProvider;
        this.preinvoice.expenseAccount = this.contactoReconocido.expenseAccountProvider;
        this.preinvoice.typePay = this.contactoReconocido.paymentTypeProvider;

        if (this.contactoReconocido.paymentProviderUid != null) {
          this.preinvoice.typePayBankAccount = this.contactoReconocido.paymentProviderUid;
        }
        if (this.contactoReconocido.providerEfectivoId != null) {
          this.preinvoice.efectivoId = this.contactoReconocido.providerEfectivoId;
        }
        if (this.contactoReconocido.providerPartnersId != null) {
          this.preinvoice.partnersId = this.contactoReconocido.providerPartnersId;
        }

        // Comprobación del número de factura
        if (this.datosFacturaIA.nFactura !== null && this.datosFacturaIA.nFactura.length > 0) {
          this.preinvoice.invoiceNumber = this.datosFacturaIA.nFactura;
        } else {
          this.snackBar.open("No se ha detectado el número de la factura.", "Cerrar", {
            duration: 8000,
            panelClass: ['mat-toolbar', 'warning']
          });
        }

        // Indicar que se debe generar el gasto asociado con la factura
        this.preinvoice.isReceptor = true;

        // Se comprueba si la fecha de la factura es válida (DD/MM/YYYY) mediante la librería de moment
        if (moment(this.datosFacturaIA.fechaFactura, 'DD/MM/YYYY').isValid()) {
          this.preinvoice.invoiceRelease = moment(this.datosFacturaIA.fechaFactura, 'DD/MM/YYYY').toDate();

          if (this.contactoReconocido !== null && this.contactoReconocido.expirationProvider > 0) {
            this.preinvoice.invoiceExpiration = moment(this.datosFacturaIA.fechaFactura, 'DD/MM/YYYY').add(this.contactoReconocido.expirationProvider, 'days').toDate();

            // En el caso de que haya un número de días de vencimiento, se establece la fecha de pago
            if (this.contactoReconocido.expirationProvider != null && this.contactoReconocido.expirationProvider > 0) {
              this.preinvoice.paided = moment(this.datosFacturaIA.fechaFactura, 'DD/MM/YYYY').add(this.contactoReconocido.expirationProvider, 'days').toDate();
            }
          }
        }

        // Incluir los impuestos de la factura
        if (this.datosFacturaIA.impuestos !== null && this.datosFacturaIA.impuestos.length > 0) {

          // Obtiene una lista de números con la lista de impuestos que tienen el importe diferente
          const impuestosConImporteDiferente: number[] = this.datosFacturaIA.impuestos.map(x => x.importe).filter((value, index, self) => self.indexOf(value) === index);

          console.log('Impuestos con importe diferente', impuestosConImporteDiferente);

          for (let j = 0; j < impuestosConImporteDiferente.length; j++) {
            // Recorrer los impuestos con el mismo importe
            // Crear una línea de factura
            const invoiceLine = new InvoiceLineModel();
            invoiceLine.product = 'Factura';
            invoiceLine.quantity = 1;

            // Lista de los impuestos que tienen el importe diferente
            const impuestos = this.datosFacturaIA.impuestos.filter(x => x.importe === impuestosConImporteDiferente[j]);

            for (let i = 0; i < impuestos.length; i++) {
              let tax = new InvoiceTaxModel();

              // Buscar el impuesto en la lista de impuestos.
              // Hay que obtener el porcentaje y el id del impuesto
              const porcentaje: string = impuestos[i].porcentaje.toString()
                .replace('%', '')
                .replace('-', '')
                .replace('.', ',');
              const posiblesImpuestos: InvoiceTaxModel[] = this.accountsAndTaxes['taxes'].filter(x => x.name.indexOf(impuestos[i].nombre) >= 0 && x.name.indexOf(porcentaje) >= 0);

              if (posiblesImpuestos.length > 0) {
                tax = posiblesImpuestos[0];
                tax.taxImport = impuestos[i].porcentaje;

                // Comprobar que el impuesto no esté ya incluido en la lista de impuestos
                if (invoiceLine.taxes.find(x => x.uid == tax.uid) == null) {
                  // Incluir el impuesto en la línea de factura
                  invoiceLine.unityAmount = impuestos[i].importe;
                  invoiceLine.product = impuestos[i].nombre;
                  invoiceLine.quantity = 1;
                  invoiceLine.taxes.push(tax);
                }
              }
            }

            this.preinvoice.invoiceLines.push(invoiceLine);
          }

        } else {
          // Incluir una línea de factura, con el importe total de la factura
          const invoiceLine = new InvoiceLineModel();
          invoiceLine.product = 'Factura';
          invoiceLine.quantity = 1;
          invoiceLine.unityAmount = this.datosFacturaIA.total;
          this.preinvoice.invoiceLines.push(invoiceLine);
        }

        // Mostrar mensaje indicando que se han aplicado los datos de la factura
        this.snackBar.open("Se han aplicado los datos de la factura", "Cerrar", {
          duration: 8000,
          panelClass: ['mat-toolbar', 'success']
        });

        this.verifyDuplicateIssuerName(this.preinvoice.issuerName);
      }
    }
  }

  /**
   * Comprueba si existe un contacto asociado a una empresa o CIF.
   * @param empresa - El nombre de la empresa.
   * @param cif - El CIF de la empresa.
   * @returns Un Observable que emite el contacto asociado si existe, de lo contrario retorna null.
   */
  comprobarContactoAsociado(empresa: string, cif: string): Observable<ContactModel> {
    const contactos: ContactModel[] = this.contactList.filter(x => x.companyName.trim().toLocaleLowerCase() == empresa.trim().toLocaleLowerCase() || x.vatNumber.trim().toLocaleLowerCase() == cif.trim().toLocaleLowerCase());
    const contact: ContactModel = contactos !== null && contactos.length > 0
      ? contactos[0]
      : null;

    if (contact !== null) {
      return new Observable(observer => {

        const observableContact = from(this.contactService.loadData(contact.uid));

        observableContact.subscribe({
          next: (response: ContactModel) => {
            observer.next(response);
            observer.complete();
          },
          error: (error: any) => {
            observer.error(error);
          }
        });
      });
    } else {
      return of(null);
    }
  }

  /**
   * Obtiene los datos de la factura mediante IA a partir de un identificador de archivo.
   * @param fileUid El identificador del archivo.
   */
  obtenerDatosFacturaIA(fileUid: string): void {
    // Extracción de la información de la factura PDF mediante IA
    this.datosFacturaIA = null;
    this.contactoReconocido = null;

    this.facturasIAService.reconocerFacturaPorFichero(fileUid).subscribe({
      next: (resultado: DatosConvertidosEnFactura) => {
        console.log('Datos de la factura', resultado);
        this.datosFacturaIA = resultado;

        // Comprueba si el contacto asociado a la empresa o CIF de la factura existe
        this.comprobarContactoAsociado(this.datosFacturaIA.empresa, this.datosFacturaIA.cif)
          .subscribe({
            next: (contact: ContactModel) => {
              if (contact !== null) {
                this.seleccionarEmisorFactura(contact.companyName);
              }
            }
          });
      }
    });
  }

  /**
   * Selecciona el emisor de la factura según el nombre del contacto.
   *
   * @param nombreContacto El nombre del contacto del emisor de la factura.
   */
  seleccionarEmisorFactura(nombreContacto: string): void {
    const contactos: ContactModel[] = this.contactList.filter(x => x.companyName.trim().toLocaleLowerCase() == nombreContacto.trim().toLocaleLowerCase());

    if (contactos !== null && contactos.length > 0) {
      this.contactSelected = contactos[0];
      this.datosFacturaIA.empresa = this.contactSelected.companyName;
    } else {
      this.contactSelected = null;
    }
  }

  // #endregion
  public trackByIndex(i: number) { return i; }

}
